<template>
  <th>
    <slot></slot>
  </th>
</template>
